import * as Yup from 'yup';

export interface Fields {
  reasonCode: string;
  comment: string;
  selectedFields: string[];
}

export const validationSchema = Yup.object().shape({
  reasonCode: Yup.string().required('Reason name is required'),
  comment: Yup.string().max(200, 'Notes cannot exceed 200 characters'),
  selectedFields: Yup.array()
    .of(Yup.string().required())
    .min(1, 'At least one field must be selected'),
});
